export const TEST_ID = 'largeSemiboldText';
